module.exports = __webpack_public_path__ + "img/footer-mask-light.1342ce07.png";